import { render, staticRenderFns } from "./lecturedetail.vue?vue&type=template&id=03389114&scoped=true"
import script from "./lecturedetail.vue?vue&type=script&lang=js"
export * from "./lecturedetail.vue?vue&type=script&lang=js"
import style0 from "./lecturedetail.vue?vue&type=style&index=0&id=03389114&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03389114",
  null
  
)

export default component.exports